module.exports = __webpack_public_path__ + "static/img/banner-empleo-interior-1680x1050.e14888c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/@banners/@responsive/search-empleos/banner-empleo-interior-1680x1050.jpg
// module id = kF0s
// module chunks = 47